import React from "react";
import {
  Grid,
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  Badge,
} from "@mui/material";
import { Link } from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";
import EmptyResult from "components/Shared/Lottie/EmptyResult";

const BranchCards = ({ branches = [] }) => {
  const validateBranches = branches.filter(
    (branch) => branch?._id && branch?.name
  );
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validateBranches?.length > 0 ? (
        validateBranches?.map((branch) => (
          <div key={branch?._id} className="group">
            <Link to={`/app/crm/branch/${branch?._id}/detail`}>
              <Card
                className="h-full transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2 }}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                      <StoreIcon
                        sx={{
                          fontSize: 20,
                          color: "primary.main",
                        }}
                      />
                    </div>
                    <div className="line-clamp-2 text-sm font-medium">
                      {branch?.name}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};

const LinkedBranchesTab = ({ municipalityDetail }) => (
  <Grid item md={12}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={3}
    >
      <Box display="inline-flex" alignItems="center" gap={1.5}>
        <Badge
          badgeContent={municipalityDetail?.branchDetails?.length}
          color="primary"
        >
          <StoreIcon style={{ color: "gray" }} />
        </Badge>

        <Typography style={{ fontWeight: 500 }}>Branches</Typography>
      </Box>
    </Box>
    <Divider />
    <Box p={2}>
      {municipalityDetail?.branchDetails?.length > 0 ? (
        <BranchCards branches={municipalityDetail?.branchDetails} />
      ) : (
        <EmptyResult height={150} />
      )}
    </Box>
  </Grid>
);

export default LinkedBranchesTab;
